import {
	DepositOwner,
	MoneySource,
	OccupationType,
	PurposeOfDeposit,
	PurposeOfLoan,
	AccommodationType,
	MaritalStatus,
	Education,
	EmploymentSector,
} from './kycTypes'
import { formatNumberWithSpaces } from 'utils/helpers'

export const kycCurrenciesAndValues: IKycCurrencyAndValues[] = [
	{
		currency: 'DKK',
		country: 'dk',
		income: [200000, 450000, 700000, 1000000, 1000001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [10000, 50000, 200000, 450000, 450001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [10000, 50000, 200000, 450000, 450001],
		purposeOfLoan: [
			PurposeOfLoan.Consumption,
			PurposeOfLoan.DebtConsolidation,
			PurposeOfLoan.Renovation,
			PurposeOfLoan.HomeExpenses,
			PurposeOfLoan.Healthcare,
			PurposeOfLoan.Travel,
			PurposeOfLoan.PurchaseVehicle,
			PurposeOfLoan.Donation,
			PurposeOfLoan.RealEstatePurchase,
			PurposeOfLoan.Other,
		],
	},
	{
		currency: '€',
		country: 'fi',
		income: [20000, 45000, 70000, 100000, 100001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.PartTime,
			OccupationType.Entrepreneur,
			OccupationType.Pensioner,
			OccupationType.Unemployed,
			OccupationType.Student,
			OccupationType.TemporarilyEmployed,
			OccupationType.Other,
		],
		moneySource: [
			MoneySource.Income,
			MoneySource.Savings,
			MoneySource.Investments,
			MoneySource.Inheritance,
			MoneySource.Gift,
			MoneySource.SalesOfProperty,
			MoneySource.SalesOfVehicle,
			MoneySource.SalesOfCulture,
			MoneySource.SaleOfCompany,
			MoneySource.Gambling,
			MoneySource.OtherBusiness,
			MoneySource.CapitalGains,
			MoneySource.InsuranceReimbursement,
			MoneySource.SocialInsuranceAllowance,
			MoneySource.Other,
		],
		purposeOfDeposit: [
			PurposeOfDeposit.Renovation,
			PurposeOfDeposit.NextInKin,
			PurposeOfDeposit.SavingForProperty,
			PurposeOfDeposit.EconomicSecurity,
			PurposeOfDeposit.PrivateConsumption,
			PurposeOfDeposit.Investment,
			PurposeOfDeposit.Retirement,
			PurposeOfDeposit.Other,
		],
		purposeOfLoan: [
			PurposeOfLoan.Consumption,
			PurposeOfLoan.DebtConsolidation,
			PurposeOfLoan.Renovation,
			PurposeOfLoan.HomeExpenses,
			PurposeOfLoan.Healthcare,
			PurposeOfLoan.Travel,
			PurposeOfLoan.PurchaseVehicle,
			PurposeOfLoan.Gambling,
			PurposeOfLoan.Donation,
			PurposeOfLoan.RealEstatePurchase,
			PurposeOfLoan.PrivateInvestment,
			PurposeOfLoan.Other,
		],
	},
	{
		currency: 'SEK',
		country: 'se',
		income: [200000, 450000, 700000, 1000000, 1000001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [10000, 50000, 200000, 450000, 450001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [10000, 50000, 200000, 450000, 450001],
		occupation: [
			OccupationType.PartTime,
			OccupationType.Entrepreneur,
			OccupationType.Unemployed,
			OccupationType.Pensioner,
			OccupationType.SickLeave,
			OccupationType.Student,
			OccupationType.EmployedByHours,
			OccupationType.Permanent,
			OccupationType.Other,
		],
		purposeOfDeposit: [
			PurposeOfDeposit.Renovation,
			PurposeOfDeposit.NextInKin,
			PurposeOfDeposit.SavingForProperty,
			PurposeOfDeposit.EconomicSecurity,
			PurposeOfDeposit.PrivateConsumption,
			PurposeOfDeposit.Investment,
			PurposeOfDeposit.Retirement,
			PurposeOfDeposit.Other,
		],
		moneySource: [
			MoneySource.OtherBusiness,
			MoneySource.OtherSavings,
			MoneySource.Inheritance,
			MoneySource.InsuranceReimbursement,
			MoneySource.SalesOfProperty,
			MoneySource.SalesOfVehicle,
			MoneySource.SaleOfCompany,
			MoneySource.Gift,
			MoneySource.CapitalGains,
			MoneySource.Income,
			MoneySource.Investments,
			MoneySource.Gambling,
			MoneySource.Other,
		],
	},
	{
		currency: 'NOK',
		country: 'no',
		income: [200000, 450000, 700000, 1000000, 1000001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [
			{
				value: '50001-200000',
				labelKey: 'expectedDepositsAmountRange',
				labelParams: {
					min: formatNumberWithSpaces(50001),
					max: formatNumberWithSpaces(200000),
				},
			},
			{
				value: '500000',
				labelKey: 'expectedDepositsAmountUp',
				labelParams: {
					value: formatNumberWithSpaces(500000),
				},
			},
			{
				value: '1000000',
				labelKey: 'expectedDepositsAmountUp',
				labelParams: {
					value: formatNumberWithSpaces(1000000),
				},
			},
			{
				value: '2000000',
				labelKey: 'expectedDepositsAmountUp',
				labelParams: {
					value: formatNumberWithSpaces(2000000),
				},
			},
		],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [
			{
				value: '<10000',
				labelKey: 'expectedWithdrawalsAmountFirst',
				labelParams: {
					value: formatNumberWithSpaces(10000),
				},
			},
			{
				value: '10001-50000',
				labelKey: 'expectedWithdrawalsAmountRange',
				labelParams: {
					min: formatNumberWithSpaces(10001),
					max: formatNumberWithSpaces(50000),
				},
			},
			{
				value: '50001-200000',
				labelKey: 'expectedWithdrawalsAmountRange',
				labelParams: {
					min: formatNumberWithSpaces(50001),
					max: formatNumberWithSpaces(200000),
				},
			},
			{
				value: '200001-450000',
				labelKey: 'expectedWithdrawalsAmountRange',
				labelParams: {
					min: formatNumberWithSpaces(200001),
					max: formatNumberWithSpaces(450000),
				},
			},
			{
				value: '>450000',
				labelKey: 'expectedWithdrawalsAmountLast',
				labelParams: {
					value: formatNumberWithSpaces(450000),
				},
			},
		],
		depositOwner: [
			DepositOwner.Yes,
			DepositOwner.YesGuardian,
			DepositOwner.Children,
			DepositOwner.Other,
		],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Entrepreneur,
			OccupationType.Pensioner,
			OccupationType.Retired,
			OccupationType.SickLeave,
			OccupationType.Student,
			OccupationType.WorkClarificationAllowance,
			OccupationType.Farmer,
			OccupationType.Substitute,
			OccupationType.StayHome,
			OccupationType.Disabled,
		],
		moneySource: [
			MoneySource.Savings,
			MoneySource.Inheritance,
			MoneySource.OtherSavings,
			MoneySource.SalesOfCulture,
			MoneySource.IncomeBussinessAndRental,
			MoneySource.Gift,
			MoneySource.CapitalGains,
			MoneySource.SaleOfCompany,
			MoneySource.SalesOfVehicle,
			MoneySource.Other,
			MoneySource.SocialInsuranceAllowance,
			MoneySource.Gambling,
			MoneySource.InsuranceReimbursement,
			MoneySource.Income,
			MoneySource.Investments,
			MoneySource.SalesOfProperty,
		],
		purposeOfDeposit: [
			PurposeOfDeposit.Investment,
			PurposeOfDeposit.NextInKin,
			PurposeOfDeposit.EconomicSecurity,
			PurposeOfDeposit.PrivateConsumption,
			PurposeOfDeposit.Renovation,
			PurposeOfDeposit.Retirement,
			PurposeOfDeposit.SavingForProperty,
			PurposeOfDeposit.Other,
		],
	},
	{
		//should be investigated for values
		currency: 'EUR',
		country: 'ee',
		income: [700, 1800, 2999, 3000],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Pensioner,
			OccupationType.Unemployed,
			OccupationType.FixedTerm,
			OccupationType.Entrepreneur,
			OccupationType.Other,
		],
	},
	{
		//should be investigated for values
		currency: 'EUR',
		country: 'lt',
		income: [700, 1200, 1800, 2500, 2501],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Pensioner,
			OccupationType.Unemployed,
			OccupationType.FixedTerm,
			OccupationType.Entrepreneur,
			OccupationType.Other,
		],
	},
	{
		//should be investigated for values
		currency: 'EUR',
		country: 'lv',
		income: [700, 1200, 1800, 2500, 2501],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Pensioner,
			OccupationType.Unemployed,
			OccupationType.FixedTerm,
			OccupationType.Entrepreneur,
			OccupationType.Other,
		],
	},
]
export interface IKycCurrencyAndValues {
	currency: string
	country: string
	income: number[]
	expectedDeposits: number[]
	expectedDepositsAmount:
		| {
				value: string
				labelKey: string
				labelParams: { [key: string]: string }
		  }[]
		| number[]
	expectedWithdrawals: number[]
	expectedWithdrawalsAmount:
		| {
				value: string
				labelKey: string
				labelParams: { [key: string]: string }
		  }[]
		| number[]
	occupation?: OccupationType[]
	purposeOfDeposit?: PurposeOfDeposit[]
	purposeOfLoan?: PurposeOfLoan[]
	moneySource?: MoneySource[]
	depositOwner?: DepositOwner[]
	maritalStatus?: MaritalStatus[]
	accommodationType?: AccommodationType[]
	education?: Education[]
	employmentSector?: EmploymentSector[]
}
